// Cookie consent utilities. Consent stored as a first-party cookie (not localStorage)
// because it must survive per-domain and be inspectable by users.

import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BASE}/api`;
const COOKIE_NAME = "sws_consent";
const COOKIE_MAX_AGE_DAYS = 365;
const POLICY_VERSION = "1.0";

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[2]) : null;
}

export function getConsentChoice() {
  // Returns "accepted" | "rejected" | null
  const raw = getCookie(COOKIE_NAME);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed.choice || null;
  } catch {
    return null;
  }
}

export function hasConsentDecision() {
  return getConsentChoice() !== null;
}

export function isAnalyticsAllowed() {
  return getConsentChoice() === "accepted";
}

export async function saveConsent(choice, sessionId = "") {
  const value = JSON.stringify({
    choice,
    ts: new Date().toISOString(),
    v: POLICY_VERSION,
  });
  setCookie(COOKIE_NAME, value, COOKIE_MAX_AGE_DAYS);
  try {
    await axios.post(
      `${API}/consent`,
      {
        choice,
        session_id: sessionId || "",
        policy_version: POLICY_VERSION,
        page: window.location.pathname,
      },
      { timeout: 4000 }
    );
  } catch {
    // Fire-and-forget; consent is still saved locally
  }
  // Broadcast so analytics can react without a page reload
  window.dispatchEvent(new CustomEvent("sws:consent-changed", { detail: { choice } }));
}

export function revokeConsent() {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  window.dispatchEvent(new CustomEvent("sws:consent-changed", { detail: { choice: null } }));
}
